import React from "react";
import PillarVideo from "../assets/pillar.mp4";
import Pistols from "../assets/Pistols.png";
import SteelhausLogo from "../assets/Steelhaus.webp";

export function VideoSection({ onOpenModal }) {
  return (
    <>
      <section
        className="videoSection"
        style={{ position: "relative", overflow: "hidden" }}>
        {/* Background Video */}
        <video
          className="videoSectionVideo"
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
          }}>
          <source src={PillarVideo} type="video/mp4" />
        </video>

        <div className="videoSectionOverlay">
          <h2 className="mainHeadline whiteText">
            Unleashing potential by maximizing
            <span className="yellowTextHighlight"> the innovation.</span>
          </h2>
        </div>
      </section>

      <section className="poweredBySection">
        <h4 className="navyText">Powered By</h4>
        <img
          src={SteelhausLogo}
          alt="Steelhaus Logo"
          className="poweredByLogo"
        />
      </section>

      <section className="globalExportsContainer">
        <h2 className="mainHeadline navyText">Global Experts</h2>
        <p className="bodyText">
          Through our strategic partnership with Steelhaus Technologies Inc.
          Pillar is able to offer the most advanced engineering, design and
          manufacturing to provide our clients with the highest quality piston
          accumulators and hydraulic components in the industry.
        </p>
        <img src={Pistols} className="pistolImg" />
        <p className="bodyText">
          Pillar is a fully certified CWB company with the ability to custom
          design and fabrication to bring your most innovative ideas to life. In
          parallel, Pillar also offers hydraulic hose and fitting solutions with
          the ability to hydro test up to 20 000 PSI for the most robust
          hydraulic systems within Canadian energy sectors.
        </p>
      </section>
    </>
  );
}
